import { MdMyLocation } from "react-icons/md";
import { FaPersonArrowDownToLine, FaPersonArrowUpFromLine, FaArrowRightLong  } from "react-icons/fa6";
import { FaFlagCheckered } from "react-icons/fa";


const GridStructure = () => {
  //bg-[#e8d1c5] bg-[#eddcd2] bg-[#fff1e6] bg-[#f0efeb] bg-[#eeddd3]
  return (
    <div className="flex w-full h-[100%]">
      {/* Columna Izquierda */}
      <div className="w-full flex flex-col h-[100%]">
        <div className="h-[12%] flex items-center justify-center w-full">
          <div className="flex justify-between w-full p-2">
            <div className="w-[5%] mr-6">
              <h2 className="text-[14px] text-textTipic font-semibold">
                Pasajeros
              </h2>
            </div>
            <div className="flex justify-around w-[90%]">
              <h2 className="flex-1 text-[14px] text-textSubtitle font-bold text-center ">9</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-bold text-center">11</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-bold text-center">12</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-bold text-center">8</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-bold text-center">4</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-bold text-center">9</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-bold text-center">0</h2>
            </div>
            <div className="w-[5%] ">
              <h2></h2>
            </div>
          </div>
        </div>

        <div className="h-[12%] flex items-center justify-center w-full">
          <div className="flex justify-between w-full p-2">
            <div className="w-[5%] mr-6">
              <h2 className="text-[14px] text-textTipic font-semibold">
              Tipo
              </h2>
            </div>
            <div className="flex justify-around w-[90%]">
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium truncate text-center border-x">A</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium truncate text-center border-x">B</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium text-center truncate border-x">C-D-E-F</h2>
            </div>
            <div className="w-[5%] ">
              <h2></h2>
            </div>
          </div>
        </div>

        <div className="h-[6%] flex items-center justify-center w-full">
          <div className="flex justify-between w-full p-2">
            <div className="w-[5%] mr-6">
              <h2 className="text-[14px] text-[#FF1313] font-semibold ">
              Cantidad
              </h2>
            </div>
            <div className="flex justify-around w-[90%]">
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center">4</h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center">6</h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center">1</h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#FF1313] font-medium text-center truncate">9</h2>
            </div>
            <div className="w-[5%] ">
              <h2></h2>
            </div>
          </div>
        </div>

        <div className="h-[12%] flex items-center justify-center w-full">
          <div className="flex justify-between w-full p-2">
            <div className="w-[5%] mr-6">
              <h2 className="text-[14px] text-textTipic font-semibold">
              Descienden
              </h2>
            </div>
            <div className="flex justify-around w-[90%]">
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 justify-center"><FaPersonArrowDownToLine color="#FF1313"/> </div>  
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>                         
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 justify-center"><FaPersonArrowDownToLine color="#FF1313"/> </div>  
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 justify-center"><FaPersonArrowDownToLine color="#FF1313"/> </div>  
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium text-center truncate text-center"></h2>
            </div>
            <div className="w-[5%] ">
              <h2></h2>
            </div>
          </div>
        </div>

        <div className=" relative h-[24%] flex items-center justify-center w-full">
          <div className="absolute border-t-2 top-1/2 border-gray-200 left-0 w-full z-0"></div>
          <div className="flex justify-between w-full p-2 z-10">
            <div className="w-[5%] mr-6  bg-white z-10">
              <div className="flex items-center gap-x-2"> <FaArrowRightLong/>  <FaArrowRightLong/>  <FaArrowRightLong/>  </div>
             
              <h2 className="text-[14px] text-textTipic font-semibold truncate">
              Orígenes
              </h2>
            </div>
            <div className="flex justify-around w-[90%] z-10">
              <div className="flex flex-1 items-center bg-white z-10"><MdMyLocation color="#384D6C"/> <h2 className="ml-2 text-[12px] truncate text-textTipic font-medium bg-white">Medellin</h2></div>  
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>                        
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 items-center text-center bg-white z-10"><MdMyLocation color="#384D6C"/> <h2 className="ml-2 text-[12px] truncate text-textTipic font-medium">San Felix</h2></div> 
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 items-center bg-white z-10"><MdMyLocation color="#384D6C"/> <h2 className="ml-2 text-[12px] truncate text-textTipic font-medium">San Pedro</h2></div> 
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 items-center bg-white z-10"><MdMyLocation color="#384D6C"/> <h2 className="ml-2 text-[12px] truncate text-textTipic font-medium">Belmira</h2></div>
              
            </div>
            <div className="w-[5%] ">
            <div className="flex flex-1 justify-center"><FaFlagCheckered color="#384D6C" size={30}/> </div> 
            </div>
          </div>
        </div>

        <div className="h-[12%] flex items-center justify-center w-full">
          <div className="flex justify-between w-full p-2">
            <div className="w-[5%] mr-6">
              <h2 className="text-[14px] text-textTipic font-semibold truncate">
              Ascenso
              </h2>
            </div>
            <div className="flex justify-around w-[90%]">
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 justify-center"><FaPersonArrowUpFromLine color="#4D814E"/> </div>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 justify-center"><FaPersonArrowUpFromLine color="#4D814E"/> </div>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>                        
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 justify-center "><FaPersonArrowUpFromLine color="#4D814E" /> </div>   
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <div className="flex flex-1 justify-center"><FaPersonArrowUpFromLine color="#4D814E"/> </div> 
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center"></h2>
            </div>
            <div className="w-[5%] ">
              <h2></h2>
            </div>
          </div>
        </div>

        <div className="h-[6%] flex items-center justify-center w-full">
          <div className="flex justify-between w-full p-2">
            <div className="w-[5%] mr-6">
              <h2 className="text-[14px] text-[#4D814E] font-semibold ">
              Cantidad
              </h2>
            </div>
            <div className="flex justify-around w-[90%]">
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center">2</h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center">1</h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center">2</h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center">6</h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium truncate text-center"></h2>
              <h2 className="flex-1 text-[14px] text-[#4D814E] font-medium text-center truncate">9</h2>
            </div>
            <div className="w-[5%] ">
              <h2></h2>
            </div>
          </div>
        </div>      

        <div className="h-[12%] flex items-center justify-center w-full">
          <div className="flex justify-between w-full p-2">
            <div className="w-[5%] mr-6">
              <h2 className="text-[14px] text-textTipic font-semibold">
              Tipo
              </h2>
            </div>
            <div className="flex justify-around w-[90%]">
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium truncate text-center border-x">A-B</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium truncate text-center border-x">C</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium truncate text-center border-x">D-E</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium truncate text-center border-x">F-G-H</h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x" ></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate text-center border-x"></h2>
              <h2 className="flex-1 text-[14px] text-textTipic font-medium truncate border-x"></h2>      
              <h2 className="flex-1 text-[14px] text-textSubtitle font-medium text-center truncate ">-</h2>
            </div>
            <div className="w-[5%] ">
              <h2></h2>
            </div>
          </div>
        </div>  
      </div>
    </div>
  );
};

export default GridStructure;
